import depsloader from "../depsloader";
import auth from "./auth";
import address from "./address";
import expose from "./expose";
import savedsearch from "./savedsearch";

export default {
  modules: {
    auth,
    expose,
    savedsearch,
    address
  },

  state: {
    loadingCnt: 0,
    loading: false,
    appTitle: null,
    appLoaded: false,
    user: {
      loggedIn: false
    }
  },

  mutations: {
    authenticationToken(state, token) {
      state.authenticationToken = token;
    },

    appTitle(state, title) {
      state.appTitle = title;
    },

    appLoaded(state) {
      state.appLoaded = true;
    },

    loading(state, f) {
      if (f) {
        state.loadingCnt++;
      } else {
        state.loadingCnt--;
      }

      state.loading = state.loadingCnt != 0;
    },

    authUser(state, user) {
      if (!user) {
        state.user = {
          loggedIn: false
        };
      } else {
        state.user = {
         email: user.email,
         loggedIn: true
       };
      }
    },

    appData(state, data) {
      state.appData = data;
    },

    userMessage(state, userMessage) {
      state.userMessage = userMessage;
    }
  },

  getters: {
  },

  actions: {
    appLoaded({ commit }) {
      commit("appTitle", document.title);
      commit("appLoaded", true);
    },

    appData({ commit, state }, data) {
      let appData = {};

      if (state.appData) {
        appData = Object.assign(appData, state.appData);
      }

      if (data != null) {
        appData = Object.assign(appData, data);
      }

      if (appData && "title" in appData) {
        let text = appData.title;
        if ("subtitle" in appData && appData.subtitle) {
          text += `: ${appData.subtitle}`;
        }
        if (text && text.indexOf("$") !== false) {
          Object.keys(appData).forEach((k) => {
            text = text.replace(`$${k}`, appData[k]);
          });
          text = text.replace(/\$\w+/g, "...");
        }
        document.title = `${text} – ${state.appTitle}`;
      } else {
        document.title = state.appTitle;
      }

      commit("appData", appData);
    },

    loading({ commit }, loading) {
      commit("loading", loading);
    },

    userMessage({ commit }, userMessage) {
      commit("userMessage", userMessage);
    },

    ajax(context, cfg) {
      const config = cfg;
      if (config.url && config.url.startsWith("/v1")) {
        config.url = `/wp-json/sw-immoapp${config.url}`;
        config.headers = {
          Authorization: `Bearer ${context.state.auth.authenticationToken}`
        };
      }

      context.commit("loading", true);
      return new Promise((resolve, reject) => {
        depsloader.load("axios").then((axios) => {
          axios(config).then((res) => {
            context.dispatch("loading", false);

            if ("method" in cfg && cfg.method.toLowerCase() === "head") {
              resolve(res);
            } else if (res.data) {
              resolve(res.data);
            } else {
              resolve(null);
            }
          }).catch((err) => {
            context.dispatch("loading", false);

            if ("hideError" in cfg && cfg.hideError) {
              reject(err);
              return;
            }

            let error = `HTTP-ERROR ${config.url}: ${err.message}`;
            if (err.response && err.response.data && err.response.data.message) {
              error = err.response.data.message;
            }

            context.dispatch("userMessage", {
              type: "error",
              msg: error
            });

            reject(err);
          });
        });
      });
    }
  }
};
